<template >
  <div class="bg-sub2">
    <div class="header-page-sub  container">
      
      <h4 class="header-history">{{title}}</h4>
      <div class="recommended-content">
        <section class="cards">
        <div class="card-recommended" v-for="item in pageOfItems" :key="item.id">
          
            <router-link :to="linktype + item.id" >
              <div class="" @click="PlayViewmoreContent(item)">
                <div class="preview-video">
                  <figure class="sixteen-nine-img">
                    <div class="btn-overlay-cate">
                      <fa icon="play" class="icon-play"/>
                    </div>
                    <div class="" v-if="item.live == 'true'">
                      <img src="../assets/img/live.png" class="icon-live-viewmore">
                    </div>
                    <img :src="item.thumb" />
                    <p class="duration" v-if="!item.live">{{item.duration}}</p>
                  </figure>
                </div>
                <div class="card-content">
                  <p class="card-title">{{ item.name }}</p>
                  <!--p class="card-date">ดูทั้งหมด {{ item.views }} คน</p-->
                  <p class="card-desc">{{ item.desc }}</p>
                </div>
              </div>
            </router-link>

            


            <!--div class="function">
              <btn class="btn-fav" type="submit" name="button"  @click="FunctionFavorite(item)">
                <fa icon="heart" class="" v-bind:class="[FavoriteActive(item.favorite) ? 'icon-fav' : 'icon-fav2']"/>
              </btn>
              <btn class="btn-history" type="submit" name="button" @click="AddWatchLater(item)"><fa icon="history" class="icon-history" /></btn>
              <btn class="btn-share" type="submit" name="button" @click.native="modalShare = true" @click="ShareLink(item)"><fa icon="share" class="icon-share"/></btn>
            </div-->
        
        </div>
        </section>
        
          

        <jw-pagination :items="viewmore" :pageSize="20" @changePage="onChangePage"></jw-pagination>
        
      </div>
      <!-- <scroll-loader :loader-method="getImagesInfo" :loader-enable="loadMore">
        <div>Loading...</div>
      </scroll-loader> -->

      <!-- Modal share -->
        <modal centered v-if="modalShare" @close="modalShare = false">
          <!--fa class="close-modal" color="danger" icon="close"@click.native="modalShare = false" /-->
      <modal-header>
        <modal-title >แชร์ลิ้งค์</modal-title>
      </modal-header>
      <modal-body>
        <div class="padding-share">
          <!--div class="text-center input-share">
            <input type="text" class="form-control shareLink" name="" value="" v-model="Link" disabled>
          </div-->
            <div class="input-link input-share">
              <input type="text" v-model="Link" id="linkURL" class="form-control shareLink" readonly="readonly">
              <btn color="primary" class="btn-chat" @click="CopyLink()"><span>คัดลอก</span></btn>
            </div>
          <!--div class="">
            <btn class="btn-email" color="white"><fa icon="envelope" class="icon-link" /> อีเมล</btn>
          </div>
          <div class="">
            <btn class="btn-facebook" color="primary"><fa icon="facebook" class="icon-social" /> facebook</btn>
          </div>
          <div class="">
            <btn class="btn-line" color=" green accent-4"><fa icon="line" class="icon-social" />Line</btn>
          </div-->
        </div>

      </modal-body>
        </modal>
        <!-- /Modal share -->
    </div>
  </div>

</template>

<script>
import config from '../config';
import axios from 'axios';
const Host = config.app.Host;
import {
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  Btn,
  Fa,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter
} from 'mdbvue';

export default {
  name: 'ViewmorePage',
  components: {
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    Btn,
    Fa,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter
  },
  data() {
    return {
      linktype: '',
      Link: '',
      modalShare: false,
      viewmore: [],
      title: '',
      pageOfItems: []
    };
  },
  mounted() {
    this.feedViewmore();
    //this.ToggleLogin();
    localStorage.pincode = '';
    //this.Session();
    
  },
  methods: {
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    Session() {
      let APIgetSession = Host + '/api/v1/member/session';
      axios.post(APIgetSession , {
        token: localStorage.token
      }).then(response => {
        if (response.data.code !== '200') {
          localStorage.emailfront = '';
          localStorage.token = '';
          localStorage.auth = 'false';
        }
      });
    },
    feedViewmore() {
      let viewmoreid = this.$route.params.data;
      switch (viewmoreid) {
        case 'livestream':
          this.ChannelLiveList();
          this.title = 'Live Streaming Wing';
          this.linktype = '/live/';
          break;
        case 'rtaf':
          this.ChannalRTAF();
          this.title = 'RTAF NEWS';
          this.linktype = '/live/';
          break;
        case 'liveevent':
          this.ChannelLiveEventList();
          this.title = 'Live Events';
          this.linktype = '/live/';
          break;
        case 'public':
          this.PublicChannel();
          this.title = 'Public Channel';
          this.linktype = '/public/';
          break;
        case 'education':
          this.EducationFeed();
          this.title = 'Education Channel';
          this.linktype = '/live/';
          break;
        case 'recommended':
          this.RecommendedFeed();
          this.title = 'Recommended';
          this.linktype = '/vod/';
          break;
        default:
          this.feedCategory();
      }
    },
    feedCategory() {
      this.linktype = '/vod/vodpublic/';
      let categoryid = this.$route.params.data;
      let APIgetCategory = Host + '/api/v1/category/video';
      axios.post(APIgetCategory , {
        category: categoryid
      }).then(response => {
        this.title = response.data.category;
        this.viewmore = response.data.result;
      });
    },
    PlayViewmoreContent(data) {
      if (data.type == 'live' || data.type == 'event') {
        document.location.assign('/#/live/' + data.id);
        location.reload();
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      } else if (data.type == 'public') {
        document.location.assign('/#/public/' + data.id);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      } else if (data.type == 'video' || data.type == 'recommended') {
        document.location.assign('/#/vodpublic/' + data.id);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      } else {
        document.location.assign('/#/vodpublic/' + data.id);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    },
    RecommendedFeed() {
      let APIgetRecommendedFeed = Host + '/api/v1/video/recommended';
      axios.post(APIgetRecommendedFeed ,{
        email: localStorage.emailfront
      }).then(response => {
        this.viewmore = response.data.result;
        console.log(this.viewmore);
        
      });
    },
    EducationFeed() {
      let APIgetEducationChannel = Host + '/api/v1/channel/education';
      axios.get(APIgetEducationChannel).then(response => {
        this.viewmore = response.data.result;
      });
    },
    PublicChannel() {
      let APIgetPublicChannel = Host + '/api/v1/channel/public';
      axios.get(APIgetPublicChannel).then(response => {
        this.viewmore = response.data.result;
      });
    },
    ChannalRTAF() {
      let APIgetChannalRTAF = Host + '/api/v1/channel';
      axios.get(APIgetChannalRTAF).then(response => {
        this.viewmore = response.data.result;
      });
    },
    ChannelLiveList() {
      let APIgetChannelList = Host + '/api/v1/channel/wing';
      axios.get(APIgetChannelList).then(response => {
        this.viewmore = response.data.result;
      });
    },
    ChannelLiveEventList() {
      let APIgetChannelLiveEventList = Host + '/api/v1/channel/event';
      axios.get(APIgetChannelLiveEventList).then(response => {
        this.viewmore = response.data.result;
      });
    },
    VideoLastUpdate() {
      let APIgetVideoLastUpdate = Host + '/api/v1/video';
      axios.post(APIgetVideoLastUpdate , {
        email: localStorage.emailfront
      }).then(response => {
        this.viewmore = response.data.result;
      });
    },
    ToggleLogin() {
      if (localStorage.auth == 'false' || !localStorage.auth) {
        this.$router.push('/');
      }
      this.modalLogin = true;
    },
    ShareLink(data) {
      this.Link = data.share;
    },
    FavoriteActive(fav) {
      if (fav === "true") {
        return true;
      }
      return false;
    },
    FunctionFavorite(data) {
      if (data.favorite == 'true') {
        this.DelFavorite(data);
      } else {
        this.AddFavorite(data);
      }
    },
    DelFavorite(data) {
      let APIgetDelFavorite = Host + '/api/v1/favorite/delete';
      axios.post(APIgetDelFavorite , {
        email: localStorage.emailfront,
        videoid: data.id
      }).then(response => {
        this.RecommendedFeed();
      });
    },
    AddFavorite(data) {
      let APIgetAddFavorite = Host + '/api/v1/favorite/add';
      axios.post(APIgetAddFavorite , {
        email: localStorage.emailfront,
        videoid: data.id
      }).then(response => {
        this.RecommendedFeed();
      });
    },
    AddWatchLater(data) {
      let APIgetAddWatchLater = Host + '/api/v1/watchlater/add';
      axios.post(APIgetAddWatchLater , {
        email: localStorage.emailfront,
        videoid: data.id
      }).then(response => {
        console.log(data.id);
      });
    },
  },
};
</script>

<style lang="css">
</style>
